
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#faa61a","data-name":"vuesax/twotone/danger"}},[_c('path',{attrs:{"d":"M15.001 18.438a.938.938 0 01-.938-.937v-6.25a.938.938 0 011.875 0v6.25a.938.938 0 01-.937.937z","opacity":".34"}}),_c('path',{attrs:{"data-name":"Vector","d":"M22.575 27.712H15a.944.944 0 01-.153-.013H7.425c-2.44 0-4.3-.881-5.244-2.481s-.811-3.661.374-5.8l3.9-7.025 3.676-6.6c1.248-2.25 2.981-3.49 4.869-3.49s3.621 1.24 4.87 3.492l3.675 6.612 3.9 7.025c1.184 2.135 1.316 4.193.372 5.8s-2.805 2.48-5.242 2.48zm-7.422-1.875h7.422c1.745 0 3.033-.554 3.626-1.56s.453-2.405-.4-3.935l-3.9-7.025-3.671-6.612c-.9-1.63-2.051-2.527-3.231-2.527s-2.327.9-3.23 2.527l-3.676 6.6-3.9 7.024c-.85 1.532-.991 2.931-.4 3.938s1.88 1.557 3.629 1.557h7.575a.944.944 0 01.156.013z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15.004 22.5h-.011a1.25 1.25 0 110-2.5h.011a1.25 1.25 0 010 2.5z","opacity":".34"}})])])
          )
        }
      }
    